import React, { useEffect, useState } from 'react';
import { StorageService } from '@src/utility/storage.service';
import WelcomeModal from "./WelcomeModal";
import APP_CONSTANT, { syncElementHeight } from './constant';
import { getOnboardingDetails, getImageName } from './WelcomeModal.service';

const WelcomeModalConnector = (props) => {
    const { STATUS_CODE } = APP_CONSTANT;
    const storageService = new StorageService;
    const [show, setShow] = useState<boolean>(false);
    const [onboardDetails, setOnboardDetails] = useState<any[]>([]);
    const [isLoader, setIsLoader] = useState<boolean>(true);
    const [selectedIndex, setSelectedIndex] = useState<number>(0);

    useEffect(() => {
        if (props?.toggle) {
            handleOpen();
        } else {
            setShow(false);
        }
    }, [props.toggle]);
    const handleOpen = async () => {
        setSelectedIndex(0);
        setShow(true);
        storageService.setAppEventDataLayerForAdobeOnModalOpen('Guide');
        const response = await getOnboardingDetails('ALL');
        if (STATUS_CODE.OK === response?.StatusCode) {
            response?.Data?.forEach((val: any) => {
                if (val?.DesignPattern === 'Row') {
                    val?.Rows?.forEach(async (row) => {
                        row.Image = getImageName(row?.Image);
                    });
                } else if (val?.DesignPattern === 'Column') {
                    val.LeftColumn.Image = getImageName(val?.LeftColumn?.Image);
                    val.RightColumn.Image = getImageName(val?.RightColumn?.Image);
                }
            });
            setOnboardDetails(response?.Data || []);
            setTimeout(() => setIsLoader(false), 1000);
        }
    };
    const handleClose = (event: any) => {
        event?.stopPropagation();
        storageService.setAppEventDataLayerForAdobeOnModalClose('Guide');
        setShow(false);
        (typeof props?.onToggle === 'function') && props?.onToggle(false);
    };
    const navigateCarousel = (event: any, index: number) => {
        event?.stopPropagation();
        if (index > selectedIndex && selectedIndex + 1 === onboardDetails.length) {
            handleClose(event);
            return;
        }
        syncElementHeight('heading');
        setSelectedIndex(index);
    };

    const uiModalProps: any = {
        show,
        data: onboardDetails,
        isLoader,
        selectedIndex,
        handleClose,
        navigateCarousel,
    };

    return (<WelcomeModal {...uiModalProps} />);
};
export default WelcomeModalConnector;
